import { cn } from '@/utils/cn';

export interface ScoreDisplayProps {
  score1: number;
  score2: number;
}

export const ScoreDisplay = ({ score1, score2 }: ScoreDisplayProps) => {
  const getScoreStyles = (currentScore: number, otherScore: number) => {
    return cn(
      'flex justify-center rounded px-3',
      currentScore > otherScore ? 'bg-green-o20' : 'bg-red-o20'
    );
  };

  return (
    <div className="flex flex-col gap-2 md:flex-row">
      <div className={getScoreStyles(score1, score2)}>{score1}</div>
      <div className={getScoreStyles(score2, score1)}>{score2}</div>
    </div>
  );
};
